import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/index";
// import VueI18n from 'vue-i18n';
// import game_seek from "@/components/game_seek";
// import activity from "@/components/activity";
// import site from "@/components/site";
// import site_get from "@/components/site_get";
// import activity_get from "@/components/activity_get";

// import world_record_details from "@/components/world_record/world_record_details";
// import name from "@/components/name";

import gamerank from "@/components/gamerank";
import record from "@/components/record";
import achievement from "@/components/achievement";

import diamond from "@/components/diamond";
import billingDetails from "@/components/billingDetails";

// 支付结果页面
import pay_details from "@/components/pay_details";

import configs from "@/config/config.js";
Vue.use(Router);

const routes = [
  {
    path: "/index",
    name: "index",
    component: Index,
    meta: {
      navShow: true,
      keepAlive: true
    }
  },
  {
    path: "/",
    redirect: {
      name: "index"
    }
  },
  {
    path: "/game_seek",
    component: resolve => require(["@/components/game_seek"], resolve),
    meta: {
      navShow: false,
      keepAlive: false
    }
  },
  {
    path: "/gamerank",
    component: gamerank,
    meta: {
      navShow: false,
      keepAlive: false
    }
  },
  // {
  //   path: "/activity",
  //   component: resolve => require(['@/components/activity'], resolve),
  //   meta: {
  //     navShow: false,
  //     keepAlive: false
  //   }
  // },
  // {
  //   path: "/site",
  //   name: "site",
  //   component: resolve => require(['@/components/site'], resolve),
  //   meta: {
  //     navShow: true,
  //     keepAlive: false
  //   },
  // },
  // {
  //   path: "/site_get",
  //   name: "site_get",
  //   component: resolve => require(['@/components/site_get'], resolve),
  //   meta: {
  //     navShow: true,
  //     keepAlive: false
  //   },
  // },
  // {
  //   path: "/activity_get",
  //   component: resolve => require(['@/components/activity_get'], resolve),
  //   meta: {
  //     navShow: false,
  //     keepAlive: false
  //   }
  // },
  // {
  //   path: "/name",
  //   component: resolve => require(['@/components/name'], resolve),
  //   meta: {
  //     navShow: false,
  //     keepAlive: false
  //   }
  // },
  // {
  //   path: "/world_record_details",
  //   component: resolve => require(['@/components/world_record/world_record_details'], resolve),
  //   meta: {
  //     navShow: false,
  //     keepAlive: false
  //   }
  // },

  {
    path: "/achievement",
    component: achievement,
    meta: {
      navShow: false,
      keepAlive: false
    }
  },
  {
    path: "/record",
    component: record,
    meta: {
      navShow: false,
      keepAlive: false
    }
  },
  {
    path: "/diamond",
    component: diamond,
    meta: {
      navShow: false,
      keepAlive: false
    }
  },
  {
    path: "/billingDetails",
    component: billingDetails,
    meta: {
      navShow: false,
      keepAlive: false
    }
  },
  {
    path: "/pay_details",
    component: pay_details,
    meta: {
      navShow: false,
      keepAlive: false
    }
  }
];
const router = new Router({
  // mode: "history",
  routes
});

// router.beforeEach((to, from, next) => {
//   if (!(to.matched.length > 0) || to.matched.some(record => record.meta && record.meta.auth === false)) {
//     next();
//     return;
//   }
//   const auth = localStorage.getItem("Bearer") || "";
//   // 判断是否是可以自动登录
//   let txn_id = GetQueryString('txn_id') || to.query.txn_id
//   let msisdn = GetQueryString('msisdn') || to.query.msisdn
//   let nickname = GetQueryString('nickname') || to.query.nickname || '';
//   var lang = GetQueryString('lang') || to.query.lang;
//   // 拿到传过来的版本号
//   let appversion = GetQueryString('appversion') || to.query.appversion;

//   // let togameid = to.query.togameid;
//   console.log('777777777')
//   console.log(nickname)
//   console.log(lang)
//   if (appversion) {
//     localStorage.setItem('appversion', appversion)
//   }

//   const { $store, $axios } = router.app;
//   console.log('------------------------------')
//   console.log(localStorage.getItem("Bearer"))
//   console.log(localStorage.getItem('msisdn') != msisdn)
//   if (!localStorage.getItem("Bearer") || localStorage.getItem('msisdn') != msisdn) {
//     localStorage.setItem('BIPVersion', '22')
//     localStorage.setItem('txn_id', txn_id)
//     localStorage.setItem('msisdn', msisdn)
//     localStorage.setItem('nickname', nickname)
//     localStorage.setItem('lang', lang)
//     localStorage.setItem('tacitlyLang', 'en')

//     //        $store
//     //          .dispatch("user/DLang", {
//     //            $axios: $axios,
//     //            lang:lang
//     //          })
//     //          .then(res => {
//     //

//     //          });

//     // $store
//     //   .dispatch("user/BipLogin", {
//     //     $axios: $axios,
//     //     type: 13,
//     //     appId: configs.bipAppId(),
//     //     txnId: localStorage.getItem('msisdn'),
//     //     nickname: localStorage.getItem('nickname'),
//     //     fpId: localStorage.getItem('msisdn'),
//     //   })
//     // 判断是否有
//     // if(!localStorage.getItem('BIPGameList')){
//     //       console.time('ActionGameList')
//     // 	$store
//     // 	  .dispatch("game/ActionGameList", {
//     // 	    $axios: $axios,
//     // 		  lang:localStorage.getItem('lang')
//     // 	  })
//     // 	  .then(res => {
//     // 	  });
//     //     console.timeEnd('ActionGameList')
//     // }else{
//     //    console.time('ActionGameIdList')
//     // 	$store
//     // 	  .dispatch("game/ActionGameIdList", {
//     // 	    $axios: $axios,
//     // 		lang:localStorage.getItem('lang')
//     // 	  })
//     // 	  .then(res => {
//     // 	  if(res == false){
//     // 		  $store
//     // 		    .dispatch("game/ActionGameList", {
//     // 		      $axios: $axios,
//     // 			  lang:localStorage.getItem('lang')
//     // 		    })
//     // 		    .then(res => {
//     // 		    });
//     // 	  }
//     // 	  });
//     //      console.timeEnd('ActionGameIdList')
//     // }
//     next()
//   } else {
//     next()
//   }

// });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js